module.exports = __webpack_public_path__ + "img/SWP_Axe_1H_06 (2).9b1821b3.png";